import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "my-3 d-flex align-center flex-wrap",
  style: {"gap":"0.5rem"}
}
const _hoisted_2 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"1rem"}
}
const _hoisted_3 = { class: "text-body-2" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  class: "d-flex align-center mb-1",
  style: {"gap":"0.5rem"}
}
const _hoisted_6 = { class: "text-h6 font-weight-bold" }
const _hoisted_7 = { class: "text-caption text-grey" }
const _hoisted_8 = { style: {"width":"200px"} }
const _hoisted_9 = { style: {"width":"120px"} }
const _hoisted_10 = { style: {"width":"110px"} }
const _hoisted_11 = { style: {"width":"120px"} }
const _hoisted_12 = { style: {"width":"120px"} }
const _hoisted_13 = {
  class: "text-right",
  style: {"width":"200px"}
}
const _hoisted_14 = { class: "text-body-2" }
const _hoisted_15 = { class: "text-body-2" }
const _hoisted_16 = { class: "text-body-2" }
const _hoisted_17 = { class: "text-body-2" }
const _hoisted_18 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_19 = { class: "text-body-2" }
const _hoisted_20 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  colspan: "8",
  class: "text-center text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_ai_report_bulk_generate_dialog = _resolveComponent("ai-report-bulk-generate-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: _ctx.breadcrumbItems
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, { value: _ctx.pageTitle }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        disabled: _ctx.isFetching || _ctx.isProcessing,
        loading: _ctx.isProcessing,
        onClick: _ctx.openBulkGenerate
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-auto-fix", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.isProcessing
            ? _ctx.$t('aiReport.generatingEllipsis')
            : _ctx.$t('aiReport.bulkGenerate')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"]),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "outlined",
        disabled: _ctx.isFetching || _ctx.draftCount === 0 || _ctx.isPublishing,
        loading: _ctx.isPublishing,
        onClick: _ctx.bulkPublish
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-publish", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.publishAllDrafts', { count: _ctx.draftCount })), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"]),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        disabled: _ctx.isFetching || _ctx.isExporting,
        loading: _ctx.isExporting,
        onClick: _ctx.exportCsv
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-file-table-outline", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.exportCsv')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    (_ctx.activeBatch && _ctx.activeBatch.status === 'processing')
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          variant: "outlined",
          color: "primary",
          icon: "mdi-progress-clock",
          class: "my-2",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('aiReport.batchGenerating', {
              id: _ctx.activeBatch.batchId,
              success: _ctx.activeBatch.successCount,
              total: _ctx.activeBatch.totalCount,
            })), 1),
              _createVNode(_component_v_progress_linear, {
                "model-value": _ctx.batchProgressPercent,
                color: "primary",
                height: "8",
                rounded: "",
                style: {"max-width":"240px"}
              }, null, 8, ["model-value"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 1,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (_ctx.quarterDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quarterDetail.classes, (cls) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cls.classId,
              class: "my-4"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(cls.className), 1),
                _createElementVNode("span", _hoisted_7, " (" + _toDisplayString(_ctx.$t('aiReport.childrenCount', {
                age: cls.ageLabel,
                count: cls.children.length,
              })) + ") ", 1)
              ]),
              _createVNode(_component_v_table, null, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('aiReport.columns.childName')), 1),
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('aiReport.columns.status')), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('aiReport.columns.generations')), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('aiReport.columns.achievedItems')), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('aiReport.columns.progressRecords')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('aiReport.columns.lastGenerated')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('aiReport.columns.lastPublished')), 1),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('aiReport.columns.actions')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cls.children, (c) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: c.childId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(c.lastName) + " " + _toDisplayString(c.firstName), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ai_report_status_chip, {
                            status: c.status
                          }, null, 8, ["status"])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(c.generationCount), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(c.achievedItemCount), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(c.progressRecordCount), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDateTime(c.lastGeneratedAt)), 1),
                          (c.lastGeneratedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " by " + _toDisplayString(c.lastGeneratedBy), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateTime(c.lastPublishedAt)), 1),
                          (c.lastPublishedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " by " + _toDisplayString(c.lastPublishedBy), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "outlined",
                            size: "small",
                            to: _ctx.childPath(c.childId)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('aiReport.openReport')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    }), 128)),
                    (cls.children.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                          _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t('aiReport.noChildrenInQuarter')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          (_ctx.quarterDetail.classes.length === 0)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "info",
                variant: "outlined"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('aiReport.noClassesInQuarter')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ai_report_bulk_generate_dialog, {
      modelValue: _ctx.bulkDialogOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bulkDialogOpen) = $event)),
      "business-year": _ctx.year,
      quarter: _ctx.quarter,
      "months-label": _ctx.quarterDetail ? _ctx.quarterDetail.monthsLabel : '',
      batch: _ctx.activeBatch,
      "is-starting": _ctx.isStartingBulk,
      onStart: _ctx.startBulkGenerate,
      onClose: _ctx.onBulkDialogClose
    }, null, 8, ["modelValue", "business-year", "quarter", "months-label", "batch", "is-starting", "onStart", "onClose"])
  ]))
}